export const VEHICLES_LIST_QUERY = /* GraphQL */ `
  query ManagementVehiclesList($input: ManagementVehiclesListInput!) {
    managementVehiclesList(input: $input) {
      count
      items {
        id
        komNr
        licensePlate
        brand
        model
        type
        vehicleType
        bodyWork
        fuelType
        constructionYear
        statusNew
        statusSold
        statusReserved
        mobilistStatusReserved
        mobilistUseForAd {
          broker
          product
          useForAd
        }
        mobilistReserveNote {
          reason
          actor
          at
        }
        mobilistAdBlockNote {
          reason
          actor
          at
        }
        dealer {
          name
          locationId
        }
      }
    }
  }
`;

export const FILTER_OPTIONS_QUERY = /* GraphQL */ `
  query ManagementVehicleFilterOptions {
    managementVehicleFilterOptions {
      name
      count
      models {
        name
        count
      }
    }
  }
`;

export const OVERRIDE_HISTORY_QUERY = /* GraphQL */ `
  query MobilistOverrideHistory($input: MobilistOverrideHistoryInput!) {
    mobilistOverrideHistory(input: $input) {
      action
      actor
      at
      reason
      reserved
      blocksAdded {
        broker
        product
      }
      blocksRemoved {
        broker
        product
      }
    }
  }
`;

export const BROKERS_QUERY = /* GraphQL */ `
  query Brokers {
    brokers {
      name
      products
      includedDealerLocationIds
      excludedDealerLocationIds
    }
  }
`;

export const UPDATE_MOBILIST_STATUS_RESERVED = /* GraphQL */ `
  mutation UpdateMobilistStatusReserved($input: UpdateMobilistStatusReservedInput!) {
    updateMobilistStatusReserved(input: $input) {
      vehicleId
      mobilistStatusReserved
      updatedAt
    }
  }
`;

export const UPDATE_MOBILIST_USE_FOR_AD = /* GraphQL */ `
  mutation UpdateMobilistUseForAd($input: UpdateMobilistUseForAdInput!) {
    updateMobilistUseForAd(input: $input) {
      vehicleId
      mobilistUseForAd {
        broker
        product
        useForAd
      }
      updatedAt
    }
  }
`;
